import React from 'react';
import c from 'classnames';
import { IconSize } from '../../../Icons/IconWrap';
import ArrowLeftIconNew from '../../../Icons/ArtStageArrowL';
import { CommonArrowButtonProps } from '../../types';

import commonStyles from '../../Slider.scss';

interface Props extends CommonArrowButtonProps {
  arrowSize?: IconSize;
  iconClassName?: string;
}

const DefaultPreviousButton: React.FC<Props> = ({
  onClick,
  className,
  iconClassName,
  arrowSize = IconSize.LARGE,
}) => {
  return (
    <button
      className={c(commonStyles['prev-btn'], className)}
      onClick={onClick}
      /**
       * We can hide these from screen readers because they have
       * access to all of the slider content without these buttons
       */
      aria-hidden={true}
      /**
       * Still adding an aria-label to avoid getting pinged by automated a11y tools
       */
      aria-label={'Previous'}
    >
      <ArrowLeftIconNew
        withPadding={false}
        className={c(commonStyles['arrow-icon'], iconClassName)}
        size={arrowSize}
      />
    </button>
  );
};

DefaultPreviousButton.displayName = 'DefaultPreviousButton';

export default DefaultPreviousButton;
